import {Tone} from "../../../components/kit";

/** Etiquetas en español y tono de los enums de selección (#13893): nunca el valor crudo en pantalla. */

export const RECRUITMENT_STATUS: Record<string, { label: string, tone: Tone }> = {
	STARTED: {label: "En curso", tone: "info"},
	FINISHED: {label: "Cerrado", tone: "success"},
	DESISTED: {label: "Desistido", tone: "neutral"},
};

export const CANDIDATE_EVENT_TYPE: Record<string, string> = {
	NOTE: "Nota",
	EMAIL: "Correo",
	CALL: "Llamada",
	INTERVIEW: "Entrevista",
	LEVEL_TEST: "Prueba de nivel",
	PROFILE_UPDATE: "Perfil actualizado",
};

export const CANDIDATE_WORK_TYPE: Record<string, string> = {
	FULL_DAY: "Jornada completa",
	PART_DAY: "Media jornada",
	PRACTICE: "Prácticas",
};
